export default "__VITE_ASSET__B7wvRh2K__"